import {
  Component,
  OnInit
} from '@angular/core';

import {
  FormBuilder,
  FormControl,
  FormGroup
} from '@angular/forms';

import {
  SkyAutocompleteSearchFunctionFilter
} from '../../core';


export class SkyLookupDemoComponent implements OnInit {
  public reactiveForm: FormGroup;

  public people: any[] = [
    { name: 'Andy' },
    { name: 'Beth' },
    { name: 'David' },
    { name: 'Frank' },
    { name: 'Grace' },
    { name: 'Isaac' },
    { name: 'John' },
    { name: 'Joyce' },
    { name: 'Lindsey' },
    { name: 'Mitch' },
    { name: 'Patty' },
    { name: 'Paul' },
    { name: 'Quincy' },
    { name: 'Sally' },
    { name: 'Susan' },
    { name: 'Vanessa' },
    { name: 'Winston' },
    { name: 'Xavier' },
    { name: 'Yolanda' },
    { name: 'Zack' }
  ];

  public friends: any[] = [
    { name: 'Susan' }
  ];

  constructor(
    private formBuilder: FormBuilder
  ) { }

  public ngOnInit(): void {
    this.createForm();

    // If you need to execute some logic after the lookup values change,
    // subscribe to Angular's built-in value changes observable.
    this.reactiveForm.valueChanges.subscribe(changes => {
      console.log('Lookup value changes:', changes);
    });
  }

  // Only show people in the search results that have not been chosen already.
  public getSearchFilters(): SkyAutocompleteSearchFunctionFilter[] {
    const friends: any[] = this.reactiveForm.controls.friends.value;
    return [
      (searchText: string, item: any): boolean => {
        const found = friends.find(friend => friend.name === item.name);
        return !found;
      }
    ];
  }

  public enableLookup() {
    this.reactiveForm.controls.friends.enable();
  }

  public disableLookup() {
    this.reactiveForm.controls.friends.disable();
  }

  public submitReactiveForm() {
    alert('Form submitted with: ' + JSON.stringify(this.reactiveForm.value));
  }

  private createForm(): void {
    this.reactiveForm = this.formBuilder.group({
      friends: new FormControl(this.friends)
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-lookup-demo',
  template: `<form
  class="lookup-demo-form"
  [formGroup]="reactiveForm"
  (ngSubmit)="submitReactiveForm()"
  novalidate>

  <div class="sky-form-group">
    <label
      id="my-friends-label"
      class="sky-control-label">
      Who are your friends?
    </label>
    <sky-lookup
      ariaLabelledBy="my-friends-label"
      formControlName="friends"
      placeholderText="Type a person's name..."
      [data]="people"
      [searchFilters]="getSearchFilters()">
    </sky-lookup>
  </div>

  <p>
    <button
      type="button"
      class="sky-btn sky-btn-default"
      (click)="disableLookup()">
      Disable lookup field
    </button>

    <button
      type="button"
      class="sky-btn sky-btn-default"
      (click)="enableLookup()">
      Enable lookup field
    </button>
  </p>

  <div class="lookup-demo-alert">
    <strong>Form model:</strong>
    <pre>{{ reactiveForm.value | json }}</pre>
  </div>

  <button
    class="sky-btn sky-btn-default"
    type="submit">
    Submit
  </button>

</form>
`,
  styles: [`.lookup-demo-form ::ng-deep .sky-form-group {
  background-color: #eeeeef;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  margin: 10px 0;
  padding: 10px;
}

.lookup-demo-form ::ng-deep h3 {
  margin-top: 30px;
}

.lookup-demo-alert {
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #cdcfd2;
  border-radius: 3px;
}

.lookup-demo-alert pre {
  margin: 0;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FormBuilder, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
